import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { usePageHidden } from '../providers/HiddenPageContext'

const useRedirect = (to: void | null | false | string): void => {
  const history = useHistory()
  // A hidden page waits until it is shown before it moves the address (HiddenPageContext)
  const hidden = usePageHidden()

  useEffect(() => {
    if (to && !hidden) history.replace(to)
  }, [history, to, hidden])
}

export default useRedirect
